// extracted by mini-css-extract-plugin
export default {"delete_resource__wrapper":"styles_delete_resource__wrapper__p-oyn","buttons__wrapper":"styles_buttons__wrapper__bkg4o"};